module.exports = __webpack_public_path__ + "img/1.beadc12f.png";